export const GET_EMAIL_MAPPING_STATUS_ERROR = 'Error in Get Email Mapping Status';
export const SEND_MAPPING_OTP_API_ERROR = 'Error in Send Email Mapping OTP';
export const VERIFY_MAPPING_OTP_API_ERROR = 'Error in Verify Email Mapping OTP';


export const prefixForEmailVeriErrorLogs = {
  ALREADY_REGISTERED: 'Already Registered',
  AUTHENTICATION_FAILED: 'Authentication Failed',
  INVALID_LOGIN_METHOD: 'invalid login method',
  NETWORK_ERROR: 'Network Error',
  RETRIES_EXHAUSTED: 'retries exhausted',
  UNKNOWN: 'unknown error',
  OTP_VERIFICATION_FAILED: 'OTP verification failed',
};
